import { render } from "./Widget11.vue?vue&type=template&id=c60e9bcc&ts=true"
import script from "./Widget11.vue?vue&type=script&lang=ts"
export * from "./Widget11.vue?vue&type=script&lang=ts"

import exportComponent from "/home/starkoms/webapps/front-comm-starkoms/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__